<template>
  <PlatformLayout>
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title class="justify-space-between">
        <h5 class="text-h5 font-weight-bold text-left">
          Cotizador
          <v-icon>mdi-counter</v-icon>
        </h5>
        <v-btn color="accent" @click="clearBuilder">Limpiar</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" md="8">
              <Lookup />
            </v-col>
            <v-col cols="12" md="4">
              <LocationSelection />
            </v-col>
          </v-row>
        </v-container>
        <v-card outlined class="mt-4">
          <CotizadorTodos />
          <CotizadorServicios />
        </v-card>
        <CotizadorOpciones />
        <CotizadorAcciones />
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "@/components/PlatformLayout";
import Lookup from "@/components/Cotizador/Lookup";
import LocationSelection from "@/components/Cotizador/LocationSelection";
import CotizadorTodos from "@/components/Cotizador/CotizadorTodos";
import CotizadorOpciones from "@/components/Cotizador/CotizadorOpciones";
import CotizadorAcciones from "@/components/Cotizador/CotizadorAcciones";
import CotizadorServicios from "@/components/Cotizador/CotizadorServicios";
import Totals from "@/components/Cotizador/Totals";

export default {
  name: "Cotizador",
  components: {
    PlatformLayout,
    Lookup,
    LocationSelection,
    CotizadorTodos,
    CotizadorOpciones,
    CotizadorAcciones,
    CotizadorServicios,
    Totals,
  },
  methods: {
    clearBuilder() {
      this.$store.dispatch("clearQuotationData");
    },
  },
  data() {
    return {};
  },
  created() {
    window.addEventListener("keydown", (event) => {
      if (event.ctrlKey == false) {
        return;
      }

      switch (event.key) {
        case "c":
          event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          ("ctrl + c");
          const lookup = document.querySelector("#lookup-anchor");
          if (lookup == null) {
            return;
          }
          lookup.focus();
          break;
        case "l":
          event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          ("ctrl + l");
          const location = document.querySelector("#location-anchor");
          if (location == null) {
            return;
          }
          location.focus();
          break;
        case "o":
          event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          ("ctrl + o");
          const options = document.querySelector("#options-anchor");
          if (options == null) {
            return;
          }
          options.focus();
          break;
        case "p":
          event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          ("ctrl + p");
          const products = document.querySelector("#products-anchor");
          if (products == null) {
            return;
          }
          products.focus();
          break;
        case "s":
          event.preventDefault();
          event.stopPropagation && event.stopPropagation();
          ("ctrl + s");
          const services = document.querySelector("#services-anchor");
          if (services == null) {
            return;
          }
          services.focus();
          break;

        default:
          break;
      }
    });
  },
  beforeDestroy() {
    this.$store.dispatch("clearQuotationData");
  },
};
</script>
